import React, { useState } from 'react';
import { Tabs, Tab, Box, Typography, Button } from '@mui/material';
import GroupedSelect from '../../../components/DemoTabs/GroupedSelect';
import SingalUserImageSelect from '../../../components/DemoTabs/SingalUserImageSelect';
import SettingsIcon from '@mui/icons-material/Settings';
import SingleDatePicker from '../../../components/Date-range-picker/SingleDatePicker';
import TableDownloadBtn from '../../../components/dropdown-select/TableDownloadBtn';
import TimeZoneDropdown from '../../../components/dropdown-select/TimezoneDropdown';
import WidgetsDropdown from '../../../layout/WidgetsDropdown';
import TimeSheetFilterSidebar from './TimeSheetFilterSidebar';
import FilterSidebar from '../../People/FilterSidebar';
import TimelineChartSet from './TimelineChartSet';
import WeeklyTimeShees from './weekly/WeeklyTimeShees';
import DailyTimeSheets from './daily/DailyTimeSheets';
import { Link, Links } from 'react-router-dom';
import MonthlyTimeSheets from './monthly/MonthlyTimeSheets';
import DateRangePicker from '../../../components/Date-range-picker/DateRangePicker';
import SingleColorProgress from '../../Dashboard/timesheets/progress-bar/SingleColorProgress';
import MultiColorProgressBar from '../../Dashboard/timesheets/progress-bar/MultiColorProgressBar';
//setting for the custome datepicker start//
import moment from 'moment';
import AddTimeModal from './AddTimeModal';
import AllNotes from '../../../components/Projects/AllNotes';
//setting for the custome datepicker end//

const segments = [
  { color: '#0076FE', value: 50 },  // 50% - Focus Time
  { color: '#00C49F', value: 30 },  // 30% - Meetings
  { color: '#FFBB28', value: 20 },  // 20% - Breaks
];

const ViewAndEdit = ({ value }) => {

  const STORAGE_KEY = 'selectedTab';

  const [tabIndex, setTabIndex] = useState(() => {
    const savedTab = localStorage.getItem(STORAGE_KEY);
    return savedTab !== null ? parseInt(savedTab, 10) : 0;
  });

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
    localStorage.setItem(STORAGE_KEY, newValue);
  };

  const [selectedProjects, setSelectedProjects] = useState([]);
  // const [selectedUsers, setSelectedUsers] = useState([]);
  // const [selectedNames, setSelectedNames] = React.useState([]);
  const projects = ['John Doe John Doe John Doe', 'Alice Johnson', 'Rahul Sharma', 'Deepa Nair'];

  // const users = [
  //   { name: 'John Doe', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
  //   { name: 'Alice Smith', image: null },
  //   { name: 'Mike Johnson', image: 'https://randomuser.me/api/portraits/men/2.jpg' },
  //   { name: 'Mike2 Johnson', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
  //   { name: 'Mike3 Johnson', image: 'https://randomuser.me/api/portraits/men/4.jpg' },
  //   { name: 'Mike4 Johnson', image: 'https://randomuser.me/api/portraits/men/5.jpg' },
  // ];

  const userList = [
    { name: 'John Doe', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
    { name: 'Alice Smith', image: null },
    { name: 'Michael Johnson', image: '' },
  ];

  const [selectedUser, setSelectedUser] = useState([]);

  const [modalOpen, setModalOpen] = useState(false);

  const [modalNotes, setModalNotes] = useState(false);

  const myWidgetOptions1 = {
    'Small widgets': [
      'Active User',
      "Avg. Worked Time",
      "Today's activity",
      'Worked today',
      'Avg. Idle Time',
      'Weekly activity',
      'Worked this week',
      'Avg. Focus Time',
      'Projects worked',
      'Spent today',
    ],
    'Large widgets': [
      'Amounts owed',
      'Apps & URLs',
      'Client Budgets',
      'Pending Payments',
      'Insights',
      'Invoices',
      'Late & Missed Shifts',
      'Last week',
      'Low activity',
      'Manual Time',
      'Members',
      'Project Budgets',
      'Projects',
      'Recent activity',
      'This week',
      'Time off requested',
      'Timesheets to approve',
      'Upcoming time off',
      'Weekly limits',]
  };
  //setting for the custome datepicker start//
  const [filterOpen, setFilterOpen] = useState(false);
  const [selectedRange, setSelectedRange] = useState({
    start: moment(),
    end: moment(),
  });
  const generateDateRange = (start, end) => {
    const dates = [];
    let current = moment(start);
    const last = moment(end);
    while (current.isSameOrBefore(last, 'day')) {
      dates.push(moment(current)); // clone each day
      current.add(1, 'day');
    }
    return dates;
  };
  //setting for the custome datepicker end//

  //monthly datepicker filter start//
  const [selectedDatepicker, setSelectedatepicker] = useState({
    start: moment().startOf('month'),
    end: moment().isSame(moment(), 'month') ? moment() : moment().endOf('month'),
  });

  const generateDatepicker = (start, end) => {
    const dates = [];
    let current = moment(start);
    const last = moment(end);
    while (current.isSameOrBefore(last, 'day')) {
      dates.push(moment(current)); // clone each day
      current.add(1, 'day');
    }
    return dates;
  };
  //monthly datepicker filter end //

  //weekly datepicker start//
  const [selectedWeekDate, setSelectedWeekDate] = useState(moment());
  const handleDateChange = (newDate) => {
    setSelectedWeekDate(moment(newDate)); // update week base date
  };
  //weekly datepicker filter end//

  const [newStart, setNewStart] = useState("");
  const [newEnd, setNewEnd] = useState("");
  const [newType, setNewType] = useState("");
  const [selectedProject, setSelectedProject] = useState(null);

  return (
    <div>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, marginBottom: '20px', }}>
        <Typography className="fw-semibold mb-0" sx={{ fontSize: '24px', color: '#1A1F36' }}>View & edit timesheets</Typography>
        <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: 1 }}>
          <Button onClick={() => setModalOpen(true)} sx={{ background: '#0076FE', borderRadius: '50px', color: '#fff', fontSize: '16px', textTransform: 'capitalize', padding: '6px 24px' }}>+Add Time</Button>
        <Link to='/feature'>
          <Button sx={{ background: '#fff', borderRadius: '50px', color: '#1A1F36', fontSize: '16px', textTransform: 'capitalize', width: '40px', height: '40px', border: '1px solid #E5E8EB', }}><SettingsIcon /></Button>
        
        </Link>

        </Box>
      </Box>
      <Box sx={{ width: '100%' }}>
        <Box className="d-flex justify-content-between align-items-center" sx={{ flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'wrap', xs: 'wrap' } }}>
          <Tabs
            value={tabIndex}
            onChange={handleChange}
            aria-label="Daily Weekly Monthly Tabs"
            TabIndicatorProps={{ style: { display: 'none' } }}
            sx={{
              bgcolor: 'transparent',
              borderRadius: 2,
              p: 1,
              display: 'inline-flex',
            }}
          >
            {['Daily', 'Weekly', 'Monthly'].map((label) => (
              <Tab
                key={label}
                label={label}
                sx={{
                  borderRadius: '50px',
                  minWidth: 80,
                  fontFamily: '"Manrope", sans-serif',
                  mx: 0.3,
                  fontSize: '14px',
                  fontWeight: '600',
                  textTransform: 'none',
                  // fontWeight: 'normal',
                  bgcolor: '#fff',
                  color: '#64748B',
                  transition: 'all 0.3s ease',
                  padding: '6px 17px',
                  minHeight: '38px',
                  maxHeight: '38px',
                  border: '1px solid rgba(229, 232, 235, 1)',
                  '&.Mui-selected': {
                    bgcolor: '#0076FE',
                    color: 'white !important',
                  },
                  '&:hover': {
                    bgcolor: 'rgba(25, 118, 210, 0.1)',
                  },
                }}
              />
            ))}
          </Tabs>
          <Box className="d-flex gap-10 align-items-center">
            <Box className="d-flex gap-10 align-items-center">
              {/* //weekly datepicker */}
              {
                tabIndex !== 0 && tabIndex === 1 && (
                  <SingleDatePicker onDateChange={handleDateChange} />
                )
              }
              {/* //monthly datepciker// */}
              {
                tabIndex !== 0 && tabIndex === 2 && (
                  <SingleDatePicker
                    onDateChange={(newDate) => {
                      const startOfMonth = moment(newDate).startOf('month');
                      const isCurrentMonth = moment(newDate).isSame(moment(), 'month');
                      const endDate = isCurrentMonth ? moment() : moment(newDate).endOf('month');
                      setSelectedatepicker({ start: startOfMonth, end: endDate });
                    }}
                  />
                )
              }
              {/* //daily datepicker// */}
              {
                tabIndex !== 1 && tabIndex === 0 && (
                  <DateRangePicker onDateChange={setSelectedRange} />
                )
              }
              {
                tabIndex !== 1 && tabIndex !== 2 && (
                  <TimeZoneDropdown />
                )
              }
              <TableDownloadBtn />
              <TimeSheetFilterSidebar />
              {
                tabIndex !== 1 && (
                  <WidgetsDropdown widgetOptions={myWidgetOptions1} />
                )
              }
              {tabIndex !== 1 && (
                <>
                  {/* {value === 0 && (<Tooltip title="Filter" arrow placement="top"><Button onClick={() => setFilterOpen(true)} sx={{ background: '#fff', borderRadius: '50px', color: '#1A1F36', fontSize: '14px', textTransform: 'capitalize', width: '40px', height: '40px', border: '1px solid #E5E8EB', }}><FilterIcon /></Button></Tooltip>)} */}
                </>
              )}
            </Box>
          </Box>
        </Box>
        <Box sx={{ margin: '15px 0', display: 'flex', justifyContent: { xl: 'end', lg: 'end', md: 'end', sm: 'start', xs: 'start' } }}>
          <Box className="d-flex gap-10 align-items-center">
            <GroupedSelect
              label="Select Project"
              options={projects}
              selectedValues={selectedProjects}
              onChange={setSelectedProjects}
            />
            <SingalUserImageSelect
              label="Select User"
              options={userList}
              selectedValue={selectedUser}
              onChange={setSelectedUser}
            />
          </Box>
        </Box>
        {/* Tab panels */}
        {tabIndex === 0 && (
          <>
            {generateDateRange(selectedRange.start, selectedRange.end).map((date, idx) => (
              <Box key={idx} className="card-body p-20 bg-base border rounded-3 mb-3">
                <Box display="flex" justifyContent="space-between" alignItems="center" gap={1} mb={3}>
                  <Typography fontSize={17} color="#1A1F36" fontWeight="600">
                    {date.isSame(moment(), 'day')
                      ? 'Today'
                      : date.format('ddd, MMM D, YYYY')}
                  </Typography>

                  <Box display="flex" alignItems="center" justifyContent="center" gap={3}>
                    <Box fontSize={14} color="#64748B" fontWeight="500" display="flex" alignItems="center" gap={1}>
                      Worked time{' '}
                      <Typography component="span" fontSize={14} color="#1A1F36" fontWeight="600">
                        2:05:24
                      </Typography>
                    </Box>
                    <Box fontSize={14} color="#64748B" fontWeight="500" display="flex" alignItems="center" gap={1}>
                      Activity{' '}
                      <Typography component="span" fontSize={14} color="#1A1F36" fontWeight="600">
                        75%
                      </Typography>
                    </Box>
                    <Box fontSize={14} color="#64748B" fontWeight="500" display="flex" alignItems="center" gap={1}>
                      Idle{' '}
                      <Typography component="span" fontSize={14} color="#1A1F36" fontWeight="600">
                        25%
                      </Typography>
                    </Box>
                    <Box fontSize={14} color="#64748B" fontWeight="500" display="flex" alignItems="center" gap={1}>
                      Manual{' '}
                      <Typography component="span" fontSize={14} color="#1A1F36" fontWeight="600">
                        0%
                      </Typography>
                    </Box>
                  </Box>

                  <Link onClick={() => setModalNotes(true)}
                    style={{
                      fontSize: '14px',
                      color: '#0084FF',
                      fontWeight: '500',
                      textTransform: 'uppercase',
                    }}
                  >
                    View Notes
                  </Link>
                </Box>

                <TimelineChartSet showTimeLabels={true} />
                <Box sx={{ borderTop: '1px solid #ccc', marginTop: '24px' }}>
                  <DailyTimeSheets />
                </Box>
              </Box>
            ))}
          </>
        )}

        {tabIndex === 1 &&
          <Box mb={2}>
            <WeeklyTimeShees WeeklyDate={selectedWeekDate} />
          </Box>
        }

        {tabIndex === 2 &&
          <Box>
            <Box className="card-body p-20 bg-base border rounded-3" sx={{ display: 'flex', }}>
              <SingleColorProgress timeStr="26:25:43" targetHours={40} />
              <Box sx={{ paddingLeft: '20px', marginLeft: '20px', width: '100%', borderLeft: '1px solid #ccc', }}> <MultiColorProgressBar
                segments={segments}
                totalLabel="Total for March"
                totalTime="2108:18:45"
              /></Box>
            </Box>
            {generateDatepicker(selectedDatepicker.start, selectedDatepicker.end).map((date, idx) => (
              <Box key={idx} mb={2}>
                <MonthlyTimeSheets date={date} />
              </Box>
            ))}
          </Box>

        }
      </Box>
      <FilterSidebar open={filterOpen} onClose={() => setFilterOpen(false)} />

      <AddTimeModal
        modalOpen={modalOpen}
        closeModal={() => setModalOpen(false)}
        newStart={newStart}
        setNewStart={setNewStart}
        newEnd={newEnd}
        setNewEnd={setNewEnd}
        newType={newType}
        setNewType={setNewType}
        selectedProject={selectedProject}
        setSelectedProject={setSelectedProject}
        data={[]}
        currentTime={0}
        ACTIVITIES={[]}
      />

      <AllNotes
        open={modalNotes}
        onClose={() => setModalNotes(false)}
      />
    </div>
  )
}
export default ViewAndEdit